module.exports = __webpack_public_path__ + "static/bureau-logo-dark-5e64c536c5f87ea1aab2d5ad1cb4a1ff.png";